"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ACTION TYPE CONSTANTS*/

var FETCH_AGENCY_REQUEST = 'app/agency/FETCH_AGENCY_REQUEST';
var FETCH_AGENCY_SUCCESS = 'app/agency/FETCH_AGENCY_SUCCESS';
var FETCH_AGENCY_FAILURE = 'app/agency/FETCH_AGENCY_FAILURE';
var _default = exports.default = {
  FETCH_AGENCY_REQUEST: FETCH_AGENCY_REQUEST,
  FETCH_AGENCY_SUCCESS: FETCH_AGENCY_SUCCESS,
  FETCH_AGENCY_FAILURE: FETCH_AGENCY_FAILURE
};